import { styled } from "@mui/material";

interface SummaryCardRootProps {
  bodyClass?: React.CSSProperties;
  footerClass?: React.CSSProperties;
};

export const SummaryCardDiv = styled('div')({
  minHeight: 150,
  width: 386,
  boxShadow: '1px 1px 8px 4px #EEEEEE',
  backgroundColor: '#FFFFFF',
  borderRadius: 12,
});

export const SummaryHeaderDiv = styled('div')({
  minHeight: 20,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: '#FCFBFA',
  borderTopLeftRadius: 12,
  borderTopRightRadius: 12,
  paddingLeft: 8,
  paddingTop: 5,
  paddingBottom: 5,
});

export const SummaryBodyDiv =  styled('div', {
  shouldForwardProp: (prop) => prop !== 'bodyClass',
})<SummaryCardRootProps>(({ bodyClass }) => ({
  ...bodyClass,
  marginTop: 14,
  padding: 0,
  minHeight: 321,
  maxHeight: 321,
}));

export const SummaryFooterDiv =  styled('div', {
  shouldForwardProp: (prop) => prop !== 'footerClass',
})<SummaryCardRootProps>(({ footerClass }) => ({
  minHeight: 1,
  height: 1,
  display: 'flex',
  alignItems: 'center',
  borderBottomLeftRadius: 12,
  borderBottomRightRadius: 12,
  padding: 5,
  ...footerClass,
}));
